// Students Module Translations
// This file contains translations for the enhanced students module components

export const studentsTranslations = {
  en: {
    // Module Titles
    bestStudents: "Best Students",
    allStudents: "All Students",
    
    // Search and Filters
    searchStudents: "Search students...",
    sortBy: "Sort by",
    sortByRank: "Rank",
    sortByPoints: "Points", 
    sortByName: "Name",
    
    // Loading and States
    loadingStudents: "Loading students...",
    noStudentsFound: "No students found",
    clearSearch: "Clear search",
    noStudentsInCourse: "No students in this course",
    
    // Pagination
    showing: "Showing",
    of: "of",
    students: "students",
    pagination: "Pagination",
    pageNumbers: "Page numbers",
    goToPage: "Go to page {page}",
    previousPage: "Previous page",
    nextPage: "Next page",
    itemsPerPage: "Items per page",
    page: "page",
    
    // Student Info
    pts: "pts",
    you: "YOU",
    positionUp: "Moved up {change} positions",
    positionDown: "Moved down {change} positions",
    
    // Actions
    close: "Close",
    showAll: "Show All",
    closeAll: "Close All"
  },
  
  uk: {
    // Module Titles
    bestStudents: "Найкращі студенти",
    allStudents: "Всі студенти",
    
    // Search and Filters
    searchStudents: "Пошук студентів...",
    sortBy: "Сортувати за",
    sortByRank: "Рангом",
    sortByPoints: "Балами",
    sortByName: "Ім'ям",
    
    // Loading and States
    loadingStudents: "Завантаження студентів...",
    noStudentsFound: "Студентів не знайдено",
    clearSearch: "Очистити пошук",
    noStudentsInCourse: "У цьому курсі немає студентів",
    
    // Pagination
    showing: "Показано",
    of: "з",
    students: "студентів",
    pagination: "Пагінація",
    pageNumbers: "Номери сторінок",
    goToPage: "Перейти на сторінку {page}",
    previousPage: "Попередня сторінка",
    nextPage: "Наступна сторінка",
    itemsPerPage: "Елементів на сторінку",
    page: "сторінка",
    
    // Student Info
    pts: "балів",
    you: "ВИ",
    positionUp: "Піднявся на {change} позицій",
    positionDown: "Опустився на {change} позицій",
    
    // Actions
    close: "Закрити",
    showAll: "Показати всіх",
    closeAll: "Закрити всіх"
  }
};

// Helper function to get translation based on current locale
export function getStudentsTranslation(key, locale = 'en', params = {}) {
  // Ensure we have a valid locale
  const validLocale = (locale === 'uk') ? 'uk' : 'en';
  
  const translations = studentsTranslations[validLocale] || studentsTranslations.en;
  let translation = translations[key] || key;
  
  // Replace parameters in translation string
  if (params && Object.keys(params).length > 0) {
    Object.keys(params).forEach(param => {
      translation = translation.replace(`{${param}}`, params[param]);
    });
  }
  
  return translation;
}

// Vue mixin for easy access to students translations
export const studentsTranslationMixin = {
  methods: {
    $tStudents(key, params = {}) {
      const locale = this.$i18n?.locale || 'en';
      return getStudentsTranslation(key, locale, params);
    }
  }
};
